import { Link } from "react-router-dom";
import { PropTypes } from "prop-types";
import { StyledUnitCard } from "../../../styles/StyledUnitCard";
import { StyledUnitContainer } from "../../../styles/StyledUnitCard/StyledUnitCard";
import { useEffect } from "react";
import { useState } from "react";
import ArrowIcon from "../../../assets/img/icons/arrow-acc.svg";
import convertStringToColor from "../../../helpers/util/convertStringToColor";
import DeleteUnitButton from "../../Unit/DeleteUnitButton";

export default function UnitTreeItem({
	id,
	name,
	color,
	state,
	myUnit,
	unitChildren,
	openDropdowns,
	setOpenDropdowns,
	parentWay,
	targetId,
	onUnitDeleted,
}) {
	const [collapsed, setCollapsed] = useState(parentWay ? (parentWay.includes(parseInt(id)) ? false : true) : true);
	const [isTarget, setIsTarget] = useState(false);
	let acronym = "";
	name.split(" ").map((e, i) => {
		if (i < 2) acronym += e.split("")[0];
	});

	useEffect(() => {
		if (targetId && targetId === parseInt(id)) setIsTarget(true);
	}, []);

	switch (state) {
		case "link":
			return (
				<>
					{unitChildren ? (
						<>
							{unitChildren.length < 1 && (
								<StyledUnitCard
									id={id}
									color={color}
									type={"link"}
									onClick={unitChildren.length > 0 ? () => setCollapsed(!collapsed) : () => {}}
									isTarget={isTarget}
								>
									<div className="name">
										<div className="icon">
											<span>{acronym}</span>
										</div>
										<span>{name}</span>
									</div>
									{!isTarget && (
										<div className="details">
											<DeleteUnitButton unitId={id} unitName={name} onDeleted={onUnitDeleted} />
											{myUnit && <span className="myUnit">My Unit</span>}
											<Link to={`/units/${id}`}>See details</Link>
										</div>
									)}
								</StyledUnitCard>
							)}
							{unitChildren.length > 0 && (
								<StyledUnitContainer className={`container ${collapsed ? "inactive" : "active"}`} collapsed={collapsed}>
									<StyledUnitCard
										id={id}
										color={color}
										type={"link"}
										collapsed={collapsed}
										onClick={unitChildren.length > 0 ? () => setCollapsed(!collapsed) : () => {}}
										isTarget={isTarget}
									>
										<img src={ArrowIcon} alt="Collapse" />
										<div className="name">
											<div className="icon">
												<span>{acronym}</span>
											</div>
											<span>{name}</span>
										</div>
										{!isTarget && (
											<div className="details">
												<DeleteUnitButton unitId={id} unitName={name} onDeleted={onUnitDeleted} />
												{myUnit && <span className="myUnit">My Unit</span>}
												<Link to={`/units/${id}`}>See details</Link>
											</div>
										)}
									</StyledUnitCard>
									{unitChildren.map((e, i) => {
										return (
											<UnitTreeItem
												key={i}
												id={e.id}
												name={e.name}
												color={convertStringToColor(e.name)}
												state="link"
												openDropdowns={openDropdowns}
												setOpenDropdowns={setOpenDropdowns}
												unitChildren={e.children}
												direction={"leftcenter"}
												myUnit={e.myUnit}
												parentWay={parentWay ? parentWay : false}
												targetId={targetId ? targetId : false}
												onUnitDeleted={onUnitDeleted}
											/>
										);
									})}
								</StyledUnitContainer>
							)}
						</>
					) : (
						<StyledUnitCard id={id} color={color} type={"link"} isTarget={isTarget}>
							<div className="name">
								<div className="icon">
									<span>{acronym}</span>
								</div>
								<span>{name}</span>
							</div>
							{!isTarget && (
								<div className="details">
									<DeleteUnitButton unitId={id} unitName={name} onDeleted={onUnitDeleted} />
									{myUnit && <span className="myUnit">My Unit</span>}
									<Link to={`/units/${id}`}>See details</Link>
								</div>
							)}
						</StyledUnitCard>
					)}
				</>
			);
		case "link-single":
			return (
				<StyledUnitCard id={id} color={color} type={"link"}>
					<div className="name">
						<div className="icon">
							<span>{acronym}</span>
						</div>
						<span>{name}</span>
					</div>
					<div className="details">
						<DeleteUnitButton unitId={id} unitName={name} onDeleted={onUnitDeleted} />
						{myUnit && <span className="myUnit">My Unit</span>}
						<Link to={`/units/${id}`}>See details</Link>
					</div>
				</StyledUnitCard>
			);
	}
}

UnitTreeItem.propTypes = {
	id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	name: PropTypes.string,
	color: PropTypes.string,
	state: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	openDropdowns: PropTypes.object,
	setOpenDropdowns: PropTypes.func,
	deleteFunc: PropTypes.func,
	direction: PropTypes.string,
	unitChildren: PropTypes.array,
	myUnit: PropTypes.bool,
	moreActionsPosition: PropTypes.string,
	parentWay: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
	targetId: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
	onUnitDeleted: PropTypes.func,
};

UnitTreeItem.defaultProps = {
	direction: "left",
	moreActionsPosition: "absolute",
	parentWay: false,
	targetId: false,
};
